import { ChangeDetectionStrategy, Component, EventEmitter, inject, Input, Output } from '@angular/core'
import { MaterialControlValueAccessor } from '../core/material-cva'
import { NgControl, ReactiveFormsModule, UntypedFormControl } from '@angular/forms'
import { NgIf } from '@angular/common'
import { MatError, MatFormField } from '@angular/material/select'
import { MatInput } from '@angular/material/input'
import { ColorPickerDirective } from 'ngx-color-picker'
import { FmxErrorsComponent } from '../errors/errors.component'

@Component({
	selector: 'app-input-color',
	template: `
		<p style="margin-bottom: 0" *ngIf="label">{{ label }}</p>
		<mat-form-field
			[appearance]="appearance"
			class="w-100 flex-row flex-nowrap"
			[class.color-picker-open]="colorPickerOpen"
		>
			<div class="flex-10 color-preview-circle" [style.background-color]="color_prop"></div>
			<input
				class="flex-70"
				style="padding-left: 15px"
				matInput
				type="text"
				[(colorPicker)]="color_prop"
				placeholder="{{ placeholder }}"
				[formControl]="control"
				[errorStateMatcher]="errorStateMatcher"
				(colorPickerClose)="colorPickerOpen = false"
				(colorPickerOpen)="colorPickerOpen = true"
			/>
			<mat-error>
				<fmx-errors [control]="externalControl" [controlLabel]="errorLabel || label || placeholder"></fmx-errors>
			</mat-error>
		</mat-form-field>
	`,
	styleUrls: ['input-color.component.css'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [NgIf, MatFormField, MatInput, ReactiveFormsModule, ColorPickerDirective, MatError, FmxErrorsComponent],
})
export class InputColorComponent extends MaterialControlValueAccessor {
	protected readonly controlDirective: NgControl

	@Output() readonly iconClick: EventEmitter<void> = new EventEmitter<void>()
	readonly control: UntypedFormControl = new UntypedFormControl()

	colorPickerOpen: boolean = false

	constructor() {
		const controlDirective = inject<NgControl>(NgControl)

		super(controlDirective)

		this.controlDirective = controlDirective
	}

	writeValue(value: unknown) {
		console.log('color', value)
		super.writeValue(value)
	}

	public get color_prop(): string {
		return this.control.value
	}

	public set color_prop(value: string) {
		this.control.setValue(value)
	}
}
